import { makeAutoObservable } from "mobx"

import { wrapSingleton } from "@src/shared/classes/utils/wrapSingleton"
import { RefundEntity } from "@src/shared/componemts/RefundForm/classses/RefundEntity"

class RefundPage {
  entity: RefundEntity | null = null

  constructor(entity: RefundEntity) {
    makeAutoObservable(this)

    this.entity = entity
  }

  setEntity(entity: RefundEntity | null) {
    this.entity = entity
  }
}

export const GRefundPage = wrapSingleton(RefundPage)
